import styles from "./faq.module.scss";
import { useState, useEffect } from "react";
import { getFaqList } from "../../../lib/faq";
const Faq = (props) => {
  const faq = getFaqList();
  const [faqList, setFaqList] = useState(faq);
  return (
    <div className={styles.faq}>
      <h2>FAQ</h2>
      {faqList.map((item, index) => {
        return (
          <div className={styles.item} key={index}>
            <div
              className={styles.class1 + " " + "row1 jb ac"}
              onClick={() => {
                item.isShow = !item.isShow;
                setFaqList([...faqList]);
              }}
            >
              <span style={item.isShow ? { color: "#1877F2" } : {}}>
                {item.title}
              </span>
              {item.isShow ? (
                <img
                  style={{ width: ".15rem", height: ".02rem" }}
                  src="/images/home/btn_-@2x.png"
                  alt="btn_-"
                />
              ) : (
                <img
                  style={{ width: ".12rem", height: ".12rem" }}
                  src="/images/home/btn_+@2x.png"
                  alt="btn_+"
                />
              )}
            </div>
            {item.isShow && (
              <div className={styles.class2}>
                <p dangerouslySetInnerHTML={{ __html: item.content }}></p>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};
export default Faq;
